export function getVisibleAttributes(attributes, isIotAdmin) {
  if (!isIotAdmin) {
    const filteredAttributes = Object.fromEntries(
      Object.entries(attributes).filter(([key]) => !key.startsWith("hidden_"))
    )
    return filteredAttributes
  }
  return attributes
}

export function getVisibleTags(tags, isIotAdmin) {
  if (!isIotAdmin) {
    const filteredTags = tags.filter((tag) => !tag.startsWith("hidden_"))
    return filteredTags
  }
  return tags
}
